<div class="sn-player__aspect-ratio" [style.paddingTop.%]="aspectRatio" *ngIf="aspectRatio"></div>

<div class="sn-player__header" *ngIf="caption || elevation">
  <div class="sn-player__caption" *ngIf="caption">{{ caption }}</div>
  <div class="sn-player__caption sn-player__elevation-caption" *ngIf="elevation && fullscreen">
    Elevation: {{ round(elevation) }}m
  </div>
</div>

<ng-content select="[snTimestamp]"></ng-content>
<ng-content select="[snPlayerContent]"></ng-content>
<ng-content select="[snWatermarkContent]"></ng-content>
<ng-content select="[snPlayerFooter]"></ng-content>
<ng-content select="[snPlayerPtz]"></ng-content>
